export default __webpack_public_path__ + "static/media/dailyorganized-white.db1d8667.svg";